import config from 'js/app/config';
import path from 'js/lib/path';

import type { BreadcrumbSchemaMarkup } from 'bundles/seo/utils/schemaMarkupUtils';
import { getSchemaBreadcrumbsList } from 'bundles/seo/utils/schemaMarkupUtils';

const getProviderMarkupData = (pageContent: $TSFixMe) => {
  return {
    '@type': 'CollegeOrUniversity',
    '@id': `${config.url.base}${pageContent?.partnerInformation?.partnerSlug}#institution`,
    name: pageContent?.partnerInformation?.partnerName,
  };
};

const getBreadcrumbListMarkupData = (pageContent: $TSFixMe, pageInfo: $TSFixMe): BreadcrumbSchemaMarkup => {
  return getSchemaBreadcrumbsList([
    {
      name: 'Online Degrees',
      absoluteUrl: `${config.url.base}degrees`,
    },
    {
      name: pageContent?.programCategory ? `${pageContent.programCategory} Degrees` : '',
      absoluteUrl: pageContent?.programCategoryId
        ? `${config.url.base}degrees/${pageContent.programCategoryId}`
        : `${config.url.base}degrees`,
    },
    {
      name: pageContent?.programName ?? '',
      absoluteUrl: pageContent?.slug ? `${config.url.base}degrees/${pageContent.slug}` : `${config.url.base}degrees`,
    },
    {
      name: pageInfo?.pageName ?? '',
      absoluteUrl: path.join(config.url.base, pageInfo?.pathName ?? ''),
    },
  ]);
};

const getCredentialCategoryMarkupData = (pageContent: $TSFixMe) => {
  return {
    '@type': 'DefinedTerm',
    '@id': 'https://credreg.net/ctdl/terms/#MasterDegree',
    name: "Master's Degree",
    inDefinedTermSet: {
      '@type': 'DefinedTermSet',
      '@id': 'https://credreg.net/ctdl/terms/',
      name: 'Credential Transparency Description Language',
    },
  };
};

export { getBreadcrumbListMarkupData, getCredentialCategoryMarkupData, getProviderMarkupData };
